/* magic-cursor.js — sparkle trail on the pointer (desktop) + a sparkle BURST on
   every click/tap (all devices) so clicks feel responsive. Lightweight: throttled,
   each sparkle is one element removed after its CSS animation. Reduced-motion aware. */
(function () {
  var reduce = false, hover = true;
  try {
    reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    hover = !(window.matchMedia && matchMedia('(hover: none)').matches);
  } catch (e) {}
  if (reduce) return;

  var COLORS = ['#ff5fa8', '#ffd24d', '#7b5cff', '#4dd0a0', '#ff9fd0'];
  var layer, last = 0;
  function ensureLayer() { if (!layer) { layer = document.createElement('div'); layer.className = 'wand-sparkles'; document.body.appendChild(layer); } return layer; }
  function spark(x, y, big) {
    var s = document.createElement('span');
    s.className = 'wand-sparkle' + (big ? ' wand-sparkle--big' : '');
    s.style.left = (x + (Math.random() * 18 - 9)) + 'px';
    s.style.top = (y + (Math.random() * 18 - 9)) + 'px';
    s.style.setProperty('--c', COLORS[(Math.random() * COLORS.length) | 0]);
    s.style.setProperty('--s', (0.55 + Math.random() * 0.85).toFixed(2));
    s.style.setProperty('--r', (Math.random() * 90 - 45) + 'deg');
    ensureLayer().appendChild(s);
    setTimeout(function () { s.remove(); }, 760);
  }
  function burst(x, y, n) { for (var i = 0; i < n; i++) spark(x + (Math.random() * 34 - 17), y + (Math.random() * 34 - 17), true); }

  // Pointer trail — desktop only.
  if (hover) {
    document.addEventListener('mousemove', function (e) {
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      if (now - last < 40) return;
      last = now;
      spark(e.clientX, e.clientY);
    }, { passive: true });
  }
  // Click / tap burst — every device, so a tap always shows feedback.
  document.addEventListener('pointerdown', function (e) {
    if (e.clientX || e.clientY) burst(e.clientX, e.clientY, 9);
  }, { passive: true });
})();
